export default __webpack_public_path__ + "static/media/pattern-002-12.9c903ab8.jpg";